import { render, staticRenderFns } from "./SolutionRatingComments.vue?vue&type=template&id=fceced0a&scoped=true"
import script from "./SolutionRatingComments.vue?vue&type=script&lang=js"
export * from "./SolutionRatingComments.vue?vue&type=script&lang=js"
import style0 from "./SolutionRatingComments.vue?vue&type=style&index=0&id=fceced0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fceced0a",
  null
  
)

export default component.exports